export default {
  root: {
    class: [
      // Shape
      "rounded-md shadow-2xl-r",
      "border-0 dark:border",

      // Position
      "absolute left-0 top-0 mt-4",
      "z-40 transform origin-center",

      // Color
      "bg-surface-0 dark:bg-surface-800",
      "text-surface-700 dark:text-surface-0/80",
      "dark:border-surface-700",

      // Before: Triangle
      "before:absolute",
      "before:left-[calc(var(--overlayArrowLeft,0)+1rem)]",
      "before:top-[-15px]",
      "before:w-0",
      "before:h-0",
      "before:border-8",
      "before:border-transparent",
      "before:border-b-white",
      "before:transform",
      "before:-translate-x-1/2",
    ],
  },
  content: {
    class: "p-5 items-center flex",
  },
};
